(function() {
	angular
		.module('ShargoApp')
		.controller('ContactController',function ($http, $rootScope, $scope, Configuration, Analytics) {
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: -1000,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: true,
					dashboard: true,
					callToAction: {
						link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : false,
						text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : '',
						target: '',
						hide: false,
						disabled: false
					},
					profile: true
				}
			};

			$scope.form = {
				name: "",
				email: "",
				phone: "",
				subject: "",
				message: "",
				check: {},
				text: {}
			};
			$scope.uploadingForm = false;

			var validPhone = "";
			$scope.checkPhone = function (){
				if(!/^[0-9]*$/.test($scope.form.phone)) {
					$scope.form.phone = validPhone;
				}
				else {
					validPhone = $scope.form.phone;
				}
			};

			$scope.sendEmail = function (email) {
				if ($scope.form.name && (!$scope.form.phone || $scope.form.phone.length == 9) && $scope.form.message && email.$valid && $scope.form.subject) {
					console.log("SEND FORM");
					Analytics.trackEvent('formulario', 'click', 'conversion', 11);
					//gtag('event', 'conversion', { 'send_to': 'AW-691648475/-UnDCMun0LUBENvv5skC', 'event_callback': function() {} });
					$scope.uploadingForm = true;
					var params = {
						name: $scope.form.name,
						email: $scope.form.email,
						phone: $scope.form.phone,
						subject: $scope.form.subject,
						body: $scope.form.message
					};
					$http.post(Configuration.apiUrl + '/contactEmail', params)
					.then(function successCallback(response) {
						console.log("SUCCESS");
						console.log(response);
						$scope.form.send = true;
						$scope.uploadingForm = false;
					}, function errorCallback(data) {
						console.log("ERROR");
						console.log(data);
						$scope.uploadingForm = false;
					});
				}
				else {
					if (!$scope.form.name) {
						$scope.form.check.name = true;
						$scope.form.text.name = 'contact.error.name';
					}
					if ($scope.form.phone && $scope.form.phone.length != 9) {
						$scope.form.check.phone = true;
						$scope.form.text.phone = 'contact.error.phone';
					}
					if (!$scope.form.message) {
						$scope.form.check.message = true;
						$scope.form.text.message = 'contact.error.message';
					}
					if (!email.$valid) {
						$scope.form.check.email = true;
						$scope.form.text.email = 'contact.error.email';
					}
					if (!$scope.form.subject) {
						$scope.form.check.subject = true;
						$scope.form.text.subject = 'contact.error.subject';
					}
				}
			};
		});
})();
